import React from "react";

class BG3 extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="131.59"
        height="111.375"
        viewBox="0 0 131.59 111.375"
      >
        <path
          id="connectionSlideBg3"
          data-name="Shape 8 copy 2"
          className="cls-1"
          d="M1077,376c12.99-17.98,89.62-21.683,105-3,19.91,24.179,17.36,64.469,3,79-28.23,28.574-78.7,22.047-94,8C1075.03,445.343,1049.32,414.305,1077,376Z"
          transform="translate(-1064.75 -360.625)"
          fill="currentColor"
        />
        <path
          id="connectionSlideIcon3"
          data-name="Forma 1"
          className="cls-1"
          d="M798.586,407.673a1.406,1.406,0,0,0-2.006,0l-4.663,4.735-1.831-1.86a1.4,1.4,0,0,0-2,0,1.454,1.454,0,0,0,0,2.032l2.834,2.875a1.39,1.39,0,0,0,1,.423,1.414,1.414,0,0,0,1-.42l5.666-5.75A1.452,1.452,0,0,0,798.586,407.673Zm0,11.5a1.406,1.406,0,0,0-2.006,0l-4.663,4.735-1.831-1.857a1.4,1.4,0,0,0-2,0,1.454,1.454,0,0,0,0,2.032l2.834,2.875a1.4,1.4,0,0,0,1,.42,1.414,1.414,0,0,0,1-.42l5.666-5.75A1.452,1.452,0,0,0,798.586,419.173Zm10.331-9.048H803.25a1.438,1.438,0,0,0,0,2.875h5.667A1.438,1.438,0,0,0,808.917,410.125Zm0,11.5H803.25a1.438,1.438,0,0,0,0,2.875h5.667A1.438,1.438,0,0,0,808.917,421.625Zm5.25-25.875H807.5v-1.437a1.428,1.428,0,0,0-1.417-1.438h-3.074a4.233,4.233,0,0,0-8.018,0h-3.074a1.428,1.428,0,0,0-1.417,1.438v1.437h-6.667A2.859,2.859,0,0,0,781,398.625v38.5A2.859,2.859,0,0,0,783.833,440h30.334A2.859,2.859,0,0,0,817,437.125v-38.5A2.859,2.859,0,0,0,814.167,395.75Zm-20.834,0h2.834a1.427,1.427,0,0,0,1.416-1.437,1.417,1.417,0,1,1,2.834,0,1.427,1.427,0,0,0,1.416,1.437h2.834v2.875H793.333V395.75Zm20.834,41.375H783.833v-38.5H790.5v1.438a1.428,1.428,0,0,0,1.417,1.437h14.166a1.428,1.428,0,0,0,1.417-1.437v-1.438h6.667v38.5Z"
          transform="translate(-733 -365)"
          fill="currentColor"
        />
      </svg>
    );
  }
}

export default BG3;
